export var createNativeAudioBufferConstructor = function createNativeAudioBufferConstructor(window) {
  if (window === null) {
    return null;
  }

  if (window.hasOwnProperty('AudioBuffer')) {
    return window.AudioBuffer;
  }

  return null;
};